<router-outlet></router-outlet>

<app-modal></app-modal>
<alert></alert>
